import React from 'react';
import DocContent from './DocContent';
import { blocks } from '../content/ReviewingPitchesContent';

export default function ReviewingPitches() {
  return <DocContent blocks={blocks} />;
}
